const VERIFIED = "Verified";
const NOT_DISCLOSED = "Not disclosed";

export const physicalAIJobs = [
  {
    id: "figure-helix-robot-learning",
    title: "Helix AI Engineer, Robot Learning",
    company: "Figure",
    companyId: "figure-ai",
    country: "United States",
    city: "San Jose",
    location: "San Jose, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "AI research",
    technology: "VLA / robot learning",
    degree: NOT_DISCLOSED,
    experience: "Hands-on real-robot learning experience",
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["Python", "C++", "PyTorch", "reinforcement learning", "behavior cloning", "robot manipulation", "VLA"],
    frameworks: ["PyTorch"],
    robots: ["Figure 03"],
    originalTitle: "Helix AI Engineer, Robot Learning",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Figure official Greenhouse listing",
    sourceUrl: "https://job-boards.greenhouse.io/figureai/jobs/4649851006",
    evidence: VERIFIED,
  },
  {
    id: "figure-wbc-rl",
    title: "Reinforcement Learning Engineer – Whole Body Control",
    company: "Figure",
    companyId: "figure-ai",
    country: "United States",
    city: "San Jose",
    location: "San Jose, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "Controls",
    technology: "Reinforcement learning / whole-body control",
    degree: NOT_DISCLOSED,
    experience: "Dynamics, controls and legged-robot RL",
    salaryMin: 150000,
    salaryMax: 350000,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: "$150,000–$350,000/year",
    skills: ["reinforcement learning", "PPO", "SAC", "domain randomization", "whole-body control", "sim-to-real"],
    frameworks: [],
    robots: ["Figure 03"],
    originalTitle: "Reinforcement Learning Engineer – Whole Body Control",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Figure official Greenhouse listing",
    sourceUrl: "https://job-boards.greenhouse.io/figureai/jobs/4671442006",
    evidence: VERIFIED,
  },
  {
    id: "figure-video-pretraining",
    title: "Helix AI Engineer, Video Pretraining",
    company: "Figure",
    companyId: "figure-ai",
    country: "United States",
    city: "San Jose",
    location: "San Jose, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "AI research",
    technology: "World models / video foundation models",
    degree: NOT_DISCLOSED,
    experience: "Large-scale video model training",
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["Python", "PyTorch", "video transformers", "diffusion models", "world models", "multimodal learning"],
    frameworks: ["PyTorch"],
    robots: ["Figure 03"],
    originalTitle: "Helix AI Engineer, Video Pretraining",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Figure official Greenhouse listing",
    sourceUrl: "https://job-boards.greenhouse.io/figureai/jobs/4671703006",
    evidence: VERIFIED,
  },
  {
    id: "figure-generative-ai",
    title: "Helix AI Engineer, Generative AI",
    company: "Figure",
    companyId: "figure-ai",
    country: "United States",
    city: "San Jose",
    location: "San Jose, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "AI research",
    technology: "World models / generative AI",
    degree: NOT_DISCLOSED,
    experience: "Generative models at scale",
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["Python", "PyTorch", "diffusion models", "world models", "synthetic data", "distributed training"],
    frameworks: ["PyTorch"],
    robots: ["Figure 03"],
    originalTitle: "Helix AI Engineer, Generative AI",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Figure official Greenhouse listing",
    sourceUrl: "https://job-boards.greenhouse.io/figureai/jobs/4671699006",
    evidence: VERIFIED,
  },
  {
    id: "figure-perception",
    title: "Helix AI Engineer, Perception",
    company: "Figure",
    companyId: "figure-ai",
    country: "United States",
    city: "San Jose",
    location: "San Jose, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "Perception",
    technology: "3D vision / VLM / visuomotor policies",
    degree: NOT_DISCLOSED,
    experience: "Production ML and computer vision",
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["3D perception", "VIO", "SLAM", "VLM", "diffusion models", "computer vision"],
    frameworks: [],
    robots: ["Figure 03"],
    originalTitle: "Helix AI Engineer, Perception",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Figure official Greenhouse listing",
    sourceUrl: "https://job-boards.greenhouse.io/figureai/jobs/4007375006",
    evidence: VERIFIED,
  },
  {
    id: "figure-wbc-infra",
    title: "AI Training Infrastructure Engineer – Humanoid Whole Body Control",
    company: "Figure",
    companyId: "figure-ai",
    country: "United States",
    city: "San Jose",
    location: "San Jose, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "AI infrastructure",
    technology: "RL training / simulation",
    degree: NOT_DISCLOSED,
    experience: "Training infrastructure for robotics or controls",
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["Python", "PyTorch", "MuJoCo", "PhysX", "reinforcement learning", "simulation", "whole-body control"],
    frameworks: ["PyTorch", "MuJoCo", "NVIDIA PhysX"],
    robots: ["Figure 03"],
    originalTitle: "AI Training Infrastructure Engineer – Humanoid Whole Body Control",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Figure official Greenhouse listing",
    sourceUrl: "https://job-boards.greenhouse.io/figureai/jobs/4674754006",
    evidence: VERIFIED,
  },
  {
    id: "figure-hand-integration",
    title: "Systems Integration Engineer - Hand Subsystem",
    company: "Figure",
    companyId: "figure-ai",
    country: "United States",
    city: "San Jose",
    location: "San Jose, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "Hardware",
    technology: "Dexterous hands / actuation",
    degree: "Bachelor’s or Master’s",
    experience: "Robotics or electromechanical integration",
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["dexterous manipulation", "controls", "sensors", "mechatronics"],
    frameworks: [],
    robots: ["Figure 03"],
    originalTitle: "Systems Integration Engineer - Hand Subsystem",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Figure official Greenhouse listing",
    sourceUrl: "https://job-boards.greenhouse.io/figureai/jobs/4612612006",
    evidence: VERIFIED,
  },
  {
    id: "figure-robot-service-tech",
    title: "Robot Service Technician (Morning Shift)",
    company: "Figure",
    companyId: "figure-ai",
    country: "United States",
    city: "San Jose",
    location: "San Jose, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Technician",
    category: "Fleet operations",
    technology: "Humanoid robot service",
    degree: NOT_DISCLOSED,
    experience: "3+ years with complex systems",
    salaryMin: 35,
    salaryMax: 65,
    currency: "USD",
    salaryPeriod: "hourly",
    salaryOriginal: "$35–$65/hour",
    skills: ["robotics", "electrical diagnostics", "mechanical assembly", "force sensors"],
    frameworks: [],
    robots: ["Figure 03"],
    originalTitle: "Robot Service Technician (Morning Shift)",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Figure official Greenhouse listing",
    sourceUrl: "https://job-boards.greenhouse.io/figureai/jobs/4392728006",
    evidence: VERIFIED,
  },
  {
    id: "figure-fleet-coordinator",
    title: "Fleet Coordinator",
    company: "Figure",
    companyId: "figure-ai",
    country: "United States",
    city: "San Jose",
    location: "San Jose, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "Deployment",
    technology: "Humanoid fleet operations",
    degree: NOT_DISCLOSED,
    experience: "Fleet planning or robotics operations preferred",
    salaryMin: 120000,
    salaryMax: 175000,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: "$120,000–$175,000/year",
    skills: ["fleet operations", "robotics deployment", "resource planning"],
    frameworks: [],
    robots: ["Figure 03"],
    originalTitle: "Fleet Coordinator",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Figure official Greenhouse listing",
    sourceUrl: "https://job-boards.greenhouse.io/figureai/jobs/4696722006",
    evidence: VERIFIED,
  },
  {
    id: "1x-robotic-learning",
    title: "Research Engineer, Robotic Learning",
    company: "1X",
    companyId: "1x-technologies",
    country: "United States",
    city: "San Carlos",
    location: "San Carlos, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "AI research",
    technology: "Robot learning / reinforcement learning",
    degree: "Bachelor’s or equivalent",
    experience: "4 years related experience",
    salaryMin: 166566,
    salaryMax: 350000,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: "$166,566–$350,000/year",
    skills: ["reinforcement learning", "imitation learning", "DAgger", "diffusion models", "C++", "distributed training", "sim-to-real"],
    frameworks: [],
    robots: ["NEO"],
    originalTitle: "Research Engineer, Robotic Learning",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "1X official careers listing",
    sourceUrl: "https://www.1x.tech/careers/research-engineer-robotic-learning",
    evidence: VERIFIED,
  },
  {
    id: "1x-rl-researcher",
    title: "AI Researcher - Reinforcement Learning",
    company: "1X",
    companyId: "1x-technologies",
    country: "United States",
    city: "San Carlos",
    location: "San Carlos, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Research",
    category: "AI research",
    technology: "Reinforcement learning",
    degree: NOT_DISCLOSED,
    experience: NOT_DISCLOSED,
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["reinforcement learning", "robot learning"],
    frameworks: [],
    robots: ["NEO"],
    originalTitle: "AI Researcher - Reinforcement Learning",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "1X official careers page",
    sourceUrl: "https://www.1x.tech/careers",
    evidence: VERIFIED,
  },
  {
    id: "1x-simulation",
    title: "Software Engineer - Simulation",
    company: "1X",
    companyId: "1x-technologies",
    country: "United States",
    city: "San Carlos",
    location: "San Carlos, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "Simulation",
    technology: "Simulation / Physical AI",
    degree: NOT_DISCLOSED,
    experience: NOT_DISCLOSED,
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["simulation", "robotics"],
    frameworks: [],
    robots: ["NEO"],
    originalTitle: "Software Engineer - Simulation",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "1X official careers page",
    sourceUrl: "https://www.1x.tech/careers",
    evidence: VERIFIED,
  },
  {
    id: "1x-controls",
    title: "Software Engineer - Robotic Controls",
    company: "1X",
    companyId: "1x-technologies",
    country: "United States",
    city: "San Carlos",
    location: "San Carlos, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "Controls",
    technology: "Robotic controls",
    degree: NOT_DISCLOSED,
    experience: NOT_DISCLOSED,
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["robot controls", "C++", "robotics"],
    frameworks: [],
    robots: ["NEO"],
    originalTitle: "Software Engineer - Robotic Controls",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "1X official careers page",
    sourceUrl: "https://www.1x.tech/careers",
    evidence: VERIFIED,
  },
  {
    id: "1x-world-model-researcher",
    title: "AI Researcher",
    company: "1X",
    companyId: "1x-technologies",
    country: "United States",
    city: "San Carlos",
    location: "San Carlos, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Research",
    category: "AI research",
    technology: "World models",
    degree: NOT_DISCLOSED,
    experience: NOT_DISCLOSED,
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["world models", "robot learning", "video models"],
    frameworks: [],
    robots: ["NEO"],
    originalTitle: "AI Researcher",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "1X official careers page - World Model Lab",
    sourceUrl: "https://www.1x.tech/careers",
    evidence: VERIFIED,
  },
  {
    id: "pi-applied-researcher",
    title: "Applied Researcher",
    company: "Physical Intelligence",
    companyId: "physical-intelligence",
    country: "United States",
    city: "San Francisco",
    location: "San Francisco, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Research",
    category: "AI research",
    technology: "VLA / robot foundation models",
    degree: NOT_DISCLOSED,
    experience: NOT_DISCLOSED,
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["VLA", "robot learning", "reinforcement learning", "multimodal learning"],
    frameworks: [],
    robots: [],
    originalTitle: "Applied Researcher",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Physical Intelligence official jobs board",
    sourceUrl: "https://jobs.ashbyhq.com/physicalintelligence",
    evidence: VERIFIED,
  },
  {
    id: "pi-robot-integration",
    title: "Robot Integration Engineer",
    company: "Physical Intelligence",
    companyId: "physical-intelligence",
    country: "United States",
    city: "San Francisco",
    location: "San Francisco, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "Robotics software",
    technology: "Robot integration / VLA deployment",
    degree: NOT_DISCLOSED,
    experience: NOT_DISCLOSED,
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["robot integration", "robotics", "VLA"],
    frameworks: [],
    robots: [],
    originalTitle: "Robot Integration Engineer",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Physical Intelligence official jobs board",
    sourceUrl: "https://jobs.ashbyhq.com/physicalintelligence",
    evidence: VERIFIED,
  },
  {
    id: "pi-ml-infra",
    title: "ML Infra Engineer",
    company: "Physical Intelligence",
    companyId: "physical-intelligence",
    country: "United States",
    city: "San Francisco",
    location: "San Francisco, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "AI infrastructure",
    technology: "Robot foundation model training",
    degree: NOT_DISCLOSED,
    experience: NOT_DISCLOSED,
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["ML infrastructure", "distributed training", "robot learning"],
    frameworks: [],
    robots: [],
    originalTitle: "ML Infra Engineer",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Physical Intelligence official jobs board",
    sourceUrl: "https://jobs.ashbyhq.com/physicalintelligence",
    evidence: VERIFIED,
  },
  {
    id: "skild-manipulation",
    title: "Robotics Engineer, Manipulation",
    company: "Skild AI",
    companyId: "skild-ai",
    country: "United States",
    city: "San Mateo",
    location: "San Mateo, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "Manipulation",
    technology: "General-purpose robot learning",
    degree: NOT_DISCLOSED,
    experience: NOT_DISCLOSED,
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["robot manipulation", "robot learning", "reinforcement learning"],
    frameworks: [],
    robots: [],
    originalTitle: "Robotics Engineer, Manipulation",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Skild AI official Greenhouse board",
    sourceUrl: "https://job-boards.greenhouse.io/skildai-careers",
    evidence: VERIFIED,
  },
  {
    id: "skild-deployment-testing",
    title: "Robotics Engineer, Deployment & Testing",
    company: "Skild AI",
    companyId: "skild-ai",
    country: "United States",
    city: "San Mateo",
    location: "San Mateo, California",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "Deployment",
    technology: "Physical AI deployment",
    degree: NOT_DISCLOSED,
    experience: NOT_DISCLOSED,
    salaryMin: null,
    salaryMax: null,
    currency: "USD",
    salaryPeriod: "annual",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["robotics deployment", "testing", "robotics"],
    frameworks: [],
    robots: [],
    originalTitle: "Robotics Engineer, Deployment & Testing",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Skild AI official Greenhouse board",
    sourceUrl: "https://job-boards.greenhouse.io/skildai-careers",
    evidence: VERIFIED,
  },
  {
    id: "galbot-embodied-foundation-model",
    title: "Embodied Foundation Model Algorithm Engineer",
    company: "Galbot",
    companyId: "galbot",
    companyChinese: "银河通用机器人",
    country: "China",
    city: "Beijing",
    province: "Beijing",
    location: "Beijing, China",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Graduate / experienced",
    category: "AI research",
    technology: "Embodied foundation models",
    degree: "Master’s",
    experience: NOT_DISCLOSED,
    salaryMin: 25000,
    salaryMax: 50000,
    currency: "CNY",
    salaryPeriod: "monthly",
    salaryOriginal: "¥25K–50K/month",
    skills: ["embodied AI", "foundation models", "robot learning"],
    frameworks: [],
    robots: [],
    originalTitle: "具身大模型算法工程师",
    datePosted: "2026-07-28",
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Northeastern University career portal - Galbot recruitment",
    sourceUrl: "https://job.neu.edu.cn/campus/view/id/562377",
    evidence: VERIFIED,
  },
  {
    id: "galbot-embodied-ai-intern",
    title: "Embodied AI Algorithm Intern",
    company: "Galbot",
    companyId: "galbot",
    companyChinese: "银河通用机器人",
    country: "China",
    city: "Beijing",
    province: "Beijing",
    location: "Beijing, China",
    workMode: "On-site",
    employmentType: "Internship",
    seniority: "Intern",
    category: "AI research",
    technology: "Embodied AI / perception / control",
    degree: NOT_DISCLOSED,
    experience: "Student role",
    salaryMin: null,
    salaryMax: null,
    currency: "CNY",
    salaryPeriod: "monthly",
    salaryOriginal: NOT_DISCLOSED,
    skills: ["embodied AI", "perception", "robot control", "simulation"],
    frameworks: [],
    robots: [],
    originalTitle: "具身智能算法实习生",
    datePosted: "2026-07-23",
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "BOSS Zhipin listing",
    sourceUrl: "https://www.zhipin.com/job_detail/ab20183f474307db1HN529q-GFRT.html",
    evidence: VERIFIED,
  },
  {
    id: "unitree-motion-control",
    title: "Robot Motion Control Algorithm Engineer",
    company: "Unitree Robotics",
    companyId: "unitree-robotics",
    companyChinese: "宇树科技",
    country: "China",
    city: "Hangzhou",
    province: "Zhejiang",
    location: "Hangzhou, Zhejiang",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Experienced",
    category: "Controls",
    technology: "Motion control / humanoid robotics",
    degree: "Master’s",
    experience: "3–5 years",
    salaryMin: 25000,
    salaryMax: 55000,
    currency: "CNY",
    salaryPeriod: "monthly",
    salaryOriginal: "¥25K–55K/month × 13 salaries",
    skills: ["motion control", "robotics", "whole-body control"],
    frameworks: [],
    robots: ["G1", "H1"],
    originalTitle: "机器人运动控制算法工程师",
    datePosted: "2026-07-17",
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Liepin - Unitree listing",
    sourceUrl: "https://m.liepin.com/company/9328741/",
    evidence: "Third-party report",
  },
  {
    id: "agi-embodied-algorithm",
    title: "Embodied AI Algorithm Engineer",
    company: "AgiBot",
    companyId: "agibot",
    companyChinese: "智元机器人",
    country: "China",
    city: "Shanghai",
    province: "Shanghai",
    location: "Shanghai, China",
    workMode: "On-site",
    employmentType: "Full-time",
    seniority: "Graduate / experienced",
    category: "AI research",
    technology: "Embodied AI / dexterous manipulation",
    degree: NOT_DISCLOSED,
    experience: NOT_DISCLOSED,
    salaryMin: 30000,
    salaryMax: 50000,
    currency: "CNY",
    salaryPeriod: "monthly",
    salaryOriginal: "¥30K–50K/month",
    skills: ["embodied AI", "reinforcement learning", "dexterous manipulation", "LLM"],
    frameworks: ["Isaac Sim", "MuJoCo"],
    robots: [],
    originalTitle: "具身智能算法工程师",
    datePosted: NOT_DISCLOSED,
    dateDiscovered: "2026-08-13",
    lastVerified: "2026-08-13",
    status: "Active",
    sourceLabel: "Liepin - AgiBot company jobs",
    sourceUrl: "https://m.liepin.com/company/13530971/",
    evidence: "Third-party report",
  },
];

export const roboticsTalentMoves = [
  {
    id: "agility-melonee-wise-2023",
    person: "Melonee Wise",
    previousOrganization: "Zebra Technologies",
    previousRole: "VP & General Manager, Robotics Automation",
    newOrganization: "Agility Robotics",
    newRole: "Chief Technology Officer",
    specialization: "Robotics product and fleet deployment",
    announcementDate: "2023-05",
    verification: "Historical announcement checked",
    sourceLabel: "Agility Robotics official announcement",
    sourceUrl: "https://www.agilityrobotics.com/content/agility-welcomes-robotics-pioneer-melonee-wise-as-new-cto-establishes-new-chief-robot-officer-role-and-celebrates-year-of-outstanding-leadership-growth",
    lastVerified: "2026-09-29",
  
"followUp": "15 May 2024: Chief Product Officer",
"additionalSources": [
  {
    "label": "Role change, 15 May 2024",
    "url": "https://www.agilityrobotics.com/content/agility-robotics-strengthens-leadership-team"
  }
]
},
  {
    id: "agility-pras-velagapudi-2023",
    person: "Pras Velagapudi",
    previousOrganization: "Berkshire Grey",
    previousRole: "VP Engineering / Chief Architect",
    newOrganization: "Agility Robotics",
    newRole: "VP of Innovation and Distinguished Engineer",
    specialization: "Robotics planning, control and AI",
    announcementDate: "2023-05",
    verification: "Historical announcement checked",
    sourceLabel: "Agility's 2023 appointments",
    sourceUrl: "https://www.agilityrobotics.com/content/agility-welcomes-robotics-pioneer-melonee-wise-as-new-cto-establishes-new-chief-robot-officer-role-and-celebrates-year-of-outstanding-leadership-growth",
    lastVerified: "2026-09-29",
  
"followUp": "15 May 2024: Chief Technology Officer",
"additionalSources": [
  {
    "label": "Role change, 15 May 2024",
    "url": "https://www.agilityrobotics.com/content/agility-robotics-strengthens-leadership-team"
  }
]
},
];

export const physicalAIUniversities = [
  {
    id: "ut-austin",
    university: "The University of Texas at Austin",
    country: "United States",
    lab: "Human Centered Robotics Lab",
    areas: ["humanoid robotics", "controls", "human-centered robotics"],
    spinouts: ["Apptronik"],
    industryLinks: ["Apptronik originated from the lab"],
    models: [],
    robots: ["Apollo lineage"],
    sourceLabel: "Apptronik official company history",
    sourceUrl: "https://apptronik.com/company/press-releases-collection/apptronik-announces-creation-of-elevate-robotics",
    lastVerified: "2026-09-29",
  
"relationshipType": "Company origin",
"documentedConnection": "Apptronik's company history identifies its origin in UT Austin's Human Centered Robotics Lab.",
"sourceLimit": "This history supplies no graduate placement rate or share of current Apptronik employees."
},
  {
    id: "carnegie-mellon",
    university: "Carnegie Mellon University",
    country: "United States",
    lab: "Robotics Institute",
    areas: ["robotics", "planning", "control", "robot learning"],
    spinouts: [],
    industryLinks: ["Agility CTO Pras Velagapudi earned B.S., M.S. and Ph.D. at CMU and later served as adjunct faculty/project scientist"],
    models: [],
    robots: [],
    sourceLabel: "Agility announcement, 15 May 2024",
    sourceUrl: "https://www.agilityrobotics.com/content/agility-robotics-strengthens-leadership-team",
    lastVerified: "2026-09-29",
  
"relationshipType": "Individual education and research appointment",
"documentedConnection": "Agility's 15 May 2024 announcement lists Pras Velagapudi's B.S., M.S. and Ph.D. at CMU and his adjunct faculty / project scientist role.",
"sourceLimit": "One executive's background is not a measure of CMU's contribution to the industry."
},
  {
    id: "stanford",
    university: "Stanford University",
    country: "United States",
    lab: "Multiple robotics and AI labs",
    areas: ["robot learning", "VLA", "manipulation", "embodied AI"],
    spinouts: [],
    industryLinks: [],
    models: ["OpenVLA collaborations"],
    robots: [],
    sourceLabel: "OpenVLA official project",
    sourceUrl: "https://openvla.github.io/",
    lastVerified: "2026-09-29",
  
"relationshipType": "Research coauthorship",
"documentedConnection": "The OpenVLA project lists Stanford among the authors' institutional affiliations.",
"sourceLimit": "Project affiliation does not establish a company spinout or hiring partnership."
},
  {
    id: "uc-berkeley",
    university: "University of California, Berkeley",
    country: "United States",
    lab: "BAIR and robotics groups",
    areas: ["robot learning", "imitation learning", "reinforcement learning", "cross-embodiment"],
    spinouts: [],
    industryLinks: [],
    models: ["OpenVLA", "Octo"],
    robots: [],
    sourceLabel: "OpenVLA official project",
    sourceUrl: "https://openvla.github.io/",
    lastVerified: "2026-09-29",
  
"relationshipType": "Research coauthorship",
"documentedConnection": "The OpenVLA and Octo project pages list UC Berkeley authors.",
"sourceLimit": "Participation in these projects is not an employment outcome or a university ranking.",
"additionalSources": [
  {
    "label": "Octo project",
    "url": "https://octo-models.github.io/"
  }
]
},
];

const activeJobs = physicalAIJobs.filter((job) => job.status === "Active" || job.status === "Recently posted");
const unique = (values) => [...new Set(values.filter(Boolean))];
const contains = (value, q) => String(value || "").toLowerCase().includes(q.toLowerCase());

export const jobsSummary = {
  total: physicalAIJobs.length,
  active: activeJobs.length,
  companies: unique(activeJobs.map((job) => job.company)).length,
  countries: unique(activeJobs.map((job) => job.country)).length,
  salaryDisclosed: activeJobs.filter((job) => job.salaryMin !== null || job.salaryMax !== null).length,
};

export const hiringIndex = unique(activeJobs.map((job) => job.company)).map((company) => {
  const rows = activeJobs.filter((job) => job.company === company);
  return {
    id: company.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
    company,
    activeJobs: rows.length,
    new7d: rows.filter((job) => job.datePosted !== NOT_DISCLOSED && job.datePosted >= "2026-08-06").length,
    new30d: rows.filter((job) => job.datePosted !== NOT_DISCLOSED && job.datePosted >= "2026-07-14").length,
    aiRoles: rows.filter((job) => contains(job.category, "ai") || contains(job.technology, "vla") || contains(job.technology, "world")).length,
    hardwareRoles: rows.filter((job) => contains(job.category, "hardware")).length,
    controlsRoles: rows.filter((job) => contains(job.category, "control") || contains(job.technology, "control")).length,
    deploymentRoles: rows.filter((job) => contains(job.category, "deployment") || contains(job.category, "fleet")).length,
    country: rows[0]?.country || NOT_DISCLOSED,
    evidence: "Derived from retained active job records",
    sourceLabel: `${rows.length} retained listings`,
    sourceUrl: rows[0]?.sourceUrl,
  };
}).sort((a, b) => b.activeJobs - a.activeJobs || a.company.localeCompare(b.company));

const skillMap = new Map();
for (const job of activeJobs) {
  for (const rawSkill of job.skills || []) {
    const normalized = rawSkill.toLowerCase() === "ros2" ? "ROS 2" : rawSkill === "pytorch" ? "PyTorch" : rawSkill;
    const item = skillMap.get(normalized) || { skill: normalized, jobs: new Set(), companies: new Set(), titles: new Set(), countries: new Set() };
    item.jobs.add(job.id);
    item.companies.add(job.company);
    item.titles.add(job.title);
    item.countries.add(job.country);
    skillMap.set(normalized, item);
  }
}
export const skillsIndex = [...skillMap.values()].map((item) => ({
  id: item.skill.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
  skill: item.skill,
  activeListings: item.jobs.size,
  share: `${((item.jobs.size / Math.max(activeJobs.length, 1)) * 100).toFixed(1)}%`,
  topCompanies: [...item.companies].slice(0, 4),
  commonTitles: [...item.titles].slice(0, 3),
  countries: [...item.countries],
  evidence: "Explicitly present in retained job source",
  sourceLabel: "Derived from retained job records",
  sourceUrl: "/jobs/physical-ai",
})).sort((a, b) => b.activeListings - a.activeListings || a.skill.localeCompare(b.skill));

export const salaryRows = activeJobs.filter((job) => job.salaryMin !== null || job.salaryMax !== null).map((job) => ({
  ...job,
  salaryRange: job.salaryOriginal,
}));

const jobColumns = [
  ["title", "Role"], ["company", "Company"], ["location", "Location"], ["technology", "Technology"],
  ["workMode", "Work mode"], ["seniority", "Seniority"], ["salaryOriginal", "Compensation"], ["status", "Status at source date"], ["lastVerified", "Source date in record"],
];

const chinaColumns = [
  ["title", "English title"], ["originalTitle", "Original title"], ["company", "Company"], ["companyChinese", "Chinese company"],
  ["city", "City"], ["technology", "Specialization"], ["degree", "Degree"], ["salaryOriginal", "Salary"], ["status", "Status at source date"],
];

export const jobsIntelligencePages = [
  {
    path: "/jobs",
    title: "Robotics & Physical AI Jobs Intelligence",
    seoTitle: "Robotics & Physical AI Jobs Intelligence Database",
    eyebrow: "Jobs intelligence",
    description: "Browse retained Physical AI and humanoid robotics listings, hiring activity, skills, disclosed salaries, talent moves and university links from one connected labor-market database.",
    updated: "2026-08-13",
    records: activeJobs,
    columns: jobColumns,
    filters: [["company", "Company"], ["country", "Country"], ["technology", "Technology"], ["seniority", "Seniority"], ["status", "Status at source date"]],
    methodology: "The hub counts retained listings only. One reposted role should map to one job entity, official company listings are preferred, and the stored status describes the source date. Availability must be checked on the employer’s page.",
  },
  {
    path: "/jobs/physical-ai",
    title: "Physical AI Jobs Tracker",
    seoTitle: "Physical AI Jobs Tracker Companies, Skills & Roles",
    eyebrow: "Global employment database",
    description: "Search retained job listings in robot learning, VLA, world models, reinforcement learning, simulation, perception, manipulation, controls, data and deployment.",
    updated: "2026-08-13",
    records: activeJobs,
    columns: jobColumns,
    filters: [["company", "Company"], ["country", "Country"], ["category", "Category"], ["technology", "Technology"], ["workMode", "Work mode"], ["status", "Status at source date"]],
    methodology: "A listing qualifies when the source explicitly connects the role to robotics, embodied AI or Physical AI. Generic software roles are excluded unless the job description ties them to robot systems.",
  },
  {
    path: "/jobs/humanoid-robotics",
    title: "Humanoid Robotics Jobs Tracker",
    seoTitle: "Humanoid Robotics Jobs AI, Controls & Hardware Roles",
    eyebrow: "Humanoid labor market",
    description: "Track jobs at humanoid robot companies across AI research, whole-body control, dexterous hands, actuation, perception, fleet operations, manufacturing and deployment.",
    updated: "2026-08-13",
    records: activeJobs.filter((job) => ["Figure", "1X", "Unitree Robotics", "AgiBot"].includes(job.company)),
    columns: jobColumns,
    filters: [["company", "Company"], ["country", "Country"], ["category", "Category"], ["technology", "Technology"]],
    methodology: "The company or role must have a direct humanoid-robotics connection. Adjacent robotics jobs are not counted only because the employer also works in AI.",
  },
  {
    path: "/jobs/china-embodied-ai",
    title: "China Embodied AI Jobs Tracker",
    seoTitle: "China Embodied AI Jobs 具身智能 Hiring Tracker",
    eyebrow: "China hiring intelligence",
    description: "Track Chinese embodied AI and humanoid robotics jobs while preserving original Chinese titles, normalized English titles, city, salary and source status.",
    updated: "2026-08-13",
    records: activeJobs.filter((job) => job.country === "China"),
    columns: chinaColumns,
    filters: [["company", "Company"], ["city", "City"], ["technology", "Specialization"], ["category", "Category"]],
    methodology: "Original Chinese wording is preserved beside the English normalized title. Compensation is stored in the original currency and period; no missing salary is estimated.",
  },
  {
    path: "/data/physical-ai-hiring-index",
    title: "Physical AI Hiring Index",
    seoTitle: "Physical AI Hiring Index by Company and Technology",
    eyebrow: "Hiring activity indicator",
    description: "Compare retained Physical AI hiring activity by company using active listings and role mix. The index measures public hiring activity, not workforce size.",
    updated: "2026-08-13",
    records: hiringIndex,
    columns: [["company", "Company"], ["activeJobs", "Listings recorded open"], ["new7d", "New 7d"], ["new30d", "New 30d"], ["aiRoles", "AI roles"], ["hardwareRoles", "Hardware"], ["controlsRoles", "Controls"], ["deploymentRoles", "Deployment"], ["country", "Country"]],
    filters: [["country", "Country"]],
    methodology: "Counts are derived only from the retained verified listing set. A larger count does not imply a larger company or total headcount.",
  },
  {
    path: "/data/physical-ai-skills",
    title: "Physical AI Skills Index",
    seoTitle: "Physical AI Skills Index Python, C++, RL, VLA & ROS",
    eyebrow: "Skills intelligence",
    description: "Measure which skills are explicitly requested in retained Physical AI job descriptions, including programming languages, ML methods, simulation, perception and robot control.",
    updated: "2026-08-13",
    records: skillsIndex,
    columns: [["skill", "Skill"], ["activeListings", "Active listings"], ["share", "Share of sample"], ["topCompanies", "Companies"], ["commonTitles", "Common roles"], ["countries", "Countries"]],
    filters: [],
    methodology: "A skill is counted only when it appears explicitly in the retained source. Similar spellings can normalize to one entity, but distinct concepts such as world model and world action model remain separate.",
  },
  {
    path: "/data/physical-ai-salaries",
    title: "Physical AI Salary Tracker",
    seoTitle: "Physical AI Salary Tracker Published Robotics Pay Ranges",
    eyebrow: "Disclosed compensation",
    description: "Compare only publicly disclosed compensation from retained Physical AI and robotics job listings, preserving original currency and annual, monthly or hourly periods.",
    updated: "2026-08-13",
    records: salaryRows,
    columns: [["title", "Role"], ["company", "Company"], ["location", "Location"], ["technology", "Specialization"], ["salaryRange", "Published range"], ["currency", "Currency"], ["salaryPeriod", "Period"], ["lastVerified", "Source date in record"]],
    filters: [["company", "Company"], ["country", "Country"], ["salaryPeriod", "Period"], ["currency", "Currency"]],
    methodology: "No missing compensation is estimated. Monthly, hourly and annual figures stay separate, and the database does not silently convert them to USD equivalents.",
  },
  {
    path: "/jobs/vla-engineer",
    title: "VLA Jobs Tracker",
    seoTitle: "VLA Engineer Jobs Vision-Language-Action Hiring Tracker",
    eyebrow: "Vision-language-action hiring",
    description: "Track robotics jobs that explicitly involve VLA, visuomotor policies, robot foundation models, multimodal policies or closely related embodied-action learning.",
    updated: "2026-08-13",
    records: activeJobs.filter((job) => (job.skills || []).some((skill) => contains(skill, "vla")) || contains(job.technology, "vla")),
    columns: jobColumns,
    filters: [["company", "Company"], ["country", "Country"], ["category", "Category"]],
    methodology: "The page does not infer VLA work from a generic ML title. The source or retained job description must explicitly connect the role to VLA, multimodal robot policy or robot foundation-model work.",
  },
  {
    path: "/jobs/world-model-robotics",
    title: "World Model Robotics Jobs",
    seoTitle: "World Model Robotics Jobs and Physical AI Research Roles",
    eyebrow: "World-model hiring",
    description: "Track jobs tied to world models, video foundation models, learned dynamics, generative robot prediction and action-conditioned physical-world modeling.",
    updated: "2026-08-13",
    records: activeJobs.filter((job) => (job.skills || []).some((skill) => contains(skill, "world model")) || contains(job.technology, "world model")),
    columns: jobColumns,
    filters: [["company", "Company"], ["country", "Country"], ["category", "Category"]],
    methodology: "Generic video-generation jobs are excluded unless the role explicitly connects prediction or generative modeling to robot perception, planning, simulation or Physical AI.",
  },
  {
    path: "/data/robotics-talent-moves",
    title: "Agility Leadership Appointments in 2023 and 2024",
    seoTitle: "Agility Leadership: Wise and Velagapudi Appointments",
    eyebrow: "Historical appointments",
    description: "Two historical Agility Robotics appointments, separating roles taken in May 2023 from the leadership changes announced on 15 May 2024.",
    updated: "2026-09-29",
    records: roboticsTalentMoves,
    columns: [
  [
    "person",
    "Person"
  ],
  [
    "previousOrganization",
    "Previous company"
  ],
  [
    "previousRole",
    "Previous role"
  ],
  [
    "newRole",
    "Role on joining Agility"
  ],
  [
    "announcementDate",
    "Joined"
  ],
  [
    "followUp",
    "Later announced change"
  ],
  [
    "lastVerified",
    "Sources checked"
  ]
],
    filters: [
  [
    "newOrganization",
    "Receiving company"
  ]
],
    methodology: "The 2023 announcement establishes the initial appointments. The 15 May 2024 announcement records later role changes. These dates remain separate; this two-person history does not establish a current leadership roster or an industry talent-flow trend.",
  
"verificationLabel": "Announcements checked September 29, 2026",
"scopeLabel": "Historical roles, not a current staff directory",
"summaryStats": [
  [
    2,
    "people documented"
  ],
  [
    1,
    "receiving company"
  ],
  [
    2,
    "announcement periods"
  ]
],
"readingNotes": [
  {
    "title": "Historical scope",
    "text": "The records concern May 2023 appointments and changes announced on 15 May 2024. Later employment or departures require separate evidence."
  },
  {
    "title": "Coverage",
    "text": "Both people joined the same company. Two selected appointments cannot measure movement between robotics companies or universities."
  }
]
},
  {
    path: "/data/physical-ai-universities",
    title: "Four University Links in Humanoid Robotics and Robot Learning",
    seoTitle: "University Links in Robotics: Four Documented Cases",
    eyebrow: "Documented relationships",
    description: "Four sourced connections involving a robotics spinout, a researcher's education and published model collaborations. These are different relationships, not a university ranking.",
    updated: "2026-09-29",
    records: physicalAIUniversities,
    columns: [
  [
    "university",
    "University"
  ],
  [
    "relationshipType",
    "Type of relationship"
  ],
  [
    "documentedConnection",
    "What the source establishes"
  ],
  [
    "sourceLimit",
    "What it does not establish"
  ],
  [
    "lastVerified",
    "Source checked"
  ]
],
    filters: [["country", "Country"]],
    methodology: "Each row identifies one documented relationship. A company spinout, an individual's education and a paper's institutional affiliations do not measure the same thing. The four selected US cases are not a sample from which hiring share or university rank can be calculated.",
  
"verificationLabel": "Sources checked September 29, 2026",
"scopeLabel": "Four selected US institutions",
"summaryStats": [
  [
    4,
    "institutions represented"
  ],
  [
    1,
    "country represented"
  ],
  [
    3,
    "relationship types"
  ]
],
"readingNotes": [
  {
    "title": "Selection limit",
    "text": "This list contains four selected cases. It does not measure graduate placements, hiring rates or the global distribution of robotics research."
  },
  {
    "title": "How to read the links",
    "text": "Institutional coauthorship establishes participation in a named publication. It does not by itself establish a commercial partnership or employment pipeline."
  }
]
},
];

export const jobsIntelligenceLinks = jobsIntelligencePages.map((page) => ({ label: page.title, to: page.path }));
export function getJobsIntelligencePageByPath(pathname) {
  return jobsIntelligencePages.find((page) => page.path === pathname) || null;
}
